import axios from "axios";

class Http {
    axios

    constructor(axios) {
        this.axios = axios
    }

    execute(url, formData = {}) {
        return new Promise((resolve, reject) => {
            this.axios.post(url, formData, {
                withCredentials: true,
                headers: {client_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone}
            }).then((response) => {
                response = response.data

                if (response.error) {
                    reject(response.error)
                    return
                }

                resolve(response.result)
            }).catch((resp) => {
                reject({
                    code: resp?.response?.status ?? 500,
                    message: resp?.response?.data?.error ?? ''
                })
            })
        })
    }

    get(url) {
        return new Promise((resolve, reject) => {
            this.axios.get(url, {
                withCredentials: true,
                headers: {client_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone}
            }).then((response) => {
                resolve(response.data)
            }).catch((resp) => {
                reject({
                    code: resp?.response?.status ?? 500,
                    message: resp?.response?.data?.error ?? ''
                })
            })
        })
    }
}

export default new Http(axios)
